import React from "react";
import { Link } from "react-router-dom";

const TickHistoryContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Analyze, Backtest, and Evolve</h2>
              <p>
                Historical accuracy matters. The Pips Tick History tool allows
                you to uncover hidden patterns, validate technical setups, and
                fine-tune your automated strategies with precision-driven
                insights. By accessing raw tick-level data, you can recreate
                true market conditions and evaluate how your strategy performs
                under varying volatility levels. This level of detail helps
                eliminate guesswork and strengthens your ability to make
                data-driven decisions. Whether you're developing expert advisors
                or optimizing discretionary trading methods, reliable historical
                data ensures every test reflects real market behavior. With
                deeper insights and clearer validation, you can continuously
                evolve and sharpen your trading edge.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                View Data Archive
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/resources/tick_history/tick_history_3.png"
                }
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TickHistoryContentThree;
